/* @flow */
import React from 'react';
// $FlowIgnore
import { MdSubdirectoryArrowRight } from 'react-icons/md';

export default function TreeDownLevelIcon({
  style
}: Object): React.Element {
  return <MdSubdirectoryArrowRight style={style} />;
}
